import { Routes, Route } from "react-router-dom";
import { AppLayout } from "../components/AppLayout";
import HomePage from "../pages/HomePage";
import Dashboard from "../pages/Dashboard";
import MonthlyTargetSales from "../pages/MonthlyTargetSales";
// import SATurnover from "../pages/SATurnover";
import Inventory from "../pages/Inventory";
import InventoryManagement from "../pages/InventoryManagement";
import ManageDiscrepancies from "../pages/ManageDiscrepancies";
import InventoryReport from "../pages/InventoryReport";
import ScanSessionReview from "../pages/ScanSessionReview";
import SAKpi from "../pages/SAKpi";
import MonthlyKpi from "../pages/MonthlyKpi";

export default function AuthenticatedRoutes(props)
{
  return (
    <Routes>
      <Route element={<AppLayout/>}>
        <Route path="/" element={<HomePage/>}/>
        <Route path="projects" element={<Dashboard/>}/>
        {/* <Route path="turnover-sa" element={<SATurnover/>}/> */}
        <Route path="inventory-management" element={<Inventory/>}/>
        <Route path="inventory-management/:inventoryId" element={<InventoryManagement/>}/>
        <Route path="inventory-management/:inventoryId/session/:sessionId" element={<ScanSessionReview/>}/>
        <Route path="inventory-management/:inventoryId/manage-discrepancies" element={<ManageDiscrepancies/>}/>
        <Route path="inventory-management/:inventoryId/report" element={<InventoryReport/>}/>
        <Route path="planned-sales" element={<MonthlyTargetSales/>}/>
        <Route path="sa-kpi" element={<SAKpi/>}/>
        <Route path="monthly-kpi" element={<MonthlyKpi/>}/>
      </Route>
    </Routes>
  );
}
